import React from 'react'
// import { Image } from 'react-native'

const AntiClippyHalf = () => (
   <img src = {require('./assets/antiClippyHalf.png')} alt="HalfClip" />
)
export default AntiClippyHalf